export const ButtonLoading = () => {
  return (
    <div className="animate-spin [animation-duration:2s] absolute size-4">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
      >
        <circle
          cx="8.5"
          cy="8"
          r="6.75"
          stroke="currentColor"
          strokeWidth="2.5"
          strokeDasharray="1 1"
        />
      </svg>
    </div>
  );
};
